import { useMemo } from 'react'

import { useExperimentsContext } from '../../experiments/components/ExperimentsContext'
import { experimentAccessorIsNowReleaseEnabled } from '../../experiments/model/experimentAccessor'

export const useIsNowEnabled = (): boolean => {
  const { experiments } = useExperimentsContext()

  return useMemo(() => {
    return experimentAccessorIsNowReleaseEnabled(experiments)
  }, [experiments])
}
